module.exports = __webpack_public_path__ + "fonts/CormorantUpright-Medium.9059220.ttf";